import { useMemo } from 'react'
import useStudentDocVaultTab from '../../../tabs/DocVault/hooks/useStudentDocVaultTab'

const SHORT_LABELS = [
	[/transcript/i, 'Transcripts'],
	[/resume|cv\b/i, 'Resume'],
	[/statement|purpose|\bsop\b/i, 'SOP'],
	[/score|test|certificate/i, 'Scores'],
	[/passport|identity|identification/i, 'ID'],
	[/financ/i, 'Finance'],
	[/portfolio/i, 'Portfolio'],
	[/essay/i, 'Essay'],
]

const shortenLabel = (label = '') => {
	const matched = SHORT_LABELS.find(([pattern]) => pattern.test(label))
	if (matched) return matched[1]
	const firstWord = String(label).trim().split(/\s+/)[0]
	return firstWord || label
}

const useDocumentsBlock = ({ studentId }) => {
	const { documentGroups, isLoading } = useStudentDocVaultTab(studentId)

	const categories = useMemo(() => {
		return (documentGroups || []).map(group => ({
			id: group.id,
			label: shortenLabel(group.title),
			count: (group.items || []).length,
		}))
	}, [documentGroups])

	const totalCount = useMemo(
		() => categories.reduce((acc, category) => acc + category.count, 0),
		[categories],
	)

	const formatCount = (value = 0) => (value > 9 ? '9+' : value)

	return {
		categories,
		totalCount,
		formatCount,
		isLoading,
	}
}

export default useDocumentsBlock
